/**
 * 图片 URL 处理工具
 */
import { API_BASE } from '@/config/apiBase'

/**
 * 将相对路径转换为完整 URL
 * @param {string} url - 图片路径（相对或绝对）
 * @param {Object} options - 可选配置
 * @param {string} options.prefix - 当 url 不是以 / 开头时添加的前缀（如用户头像使用 /uploads/user-images/）
 * @returns {string}
 */
export function getImageUrl(url, options = {}) {
  if (!url) return ''
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }
  if (url.startsWith('data:')) {
    return url
  }
  // 前端 public 目录下的静态资源，使用当前页同源
  if (url.startsWith('/badge/') || url.startsWith('/image/')) {
    return url
  }
  const base = (API_BASE || '').replace(/\/$/, '')
  const { prefix } = options
  if (prefix && !url.startsWith('/')) {
    const prefixNorm = prefix.startsWith('/') ? prefix : `/${prefix}`
    return `${base}${prefixNorm}${url.startsWith('/') ? url.slice(1) : url}`
  }
  return `${base}${url.startsWith('/') ? url : '/' + url}`
}

/**
 * 用户头像 URL（快捷方法）
 * @param {string} url - 头像路径
 * @returns {string}
 */
export function getUserImageUrl(url) {
  return getImageUrl(url, { prefix: '/uploads/user-images/' })
}
